import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "seach-wrapper" }
const _hoisted_2 = ["value", "placeholder", "aria-label"]
const _hoisted_3 = ["aria-label"]


export default /*#__PURE__*/_defineComponent({
  __name: 'StorySearchInput',
  props: {
  modelValue: String,
  placeholder: String,
  inputAriaLabel: String,
  buttonAriaLabel: String
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
    (event: 'update:modelValue', payload: string): void;
}), expose: any, slots: any, attrs: any }) {





const updateValue = (event: Event) => {
    emit('update:modelValue', (event.target as HTMLInputElement).value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      onInput: updateValue,
      value: __props.modelValue,
      class: "search-input",
      placeholder: __props.placeholder,
      "aria-label": __props.inputAriaLabel
    }, null, 40, _hoisted_2),
    _createElementVNode("button", {
      class: "btn-search",
      type: "button",
      "aria-label": __props.buttonAriaLabel
    }, null, 8, _hoisted_3)
  ]))
}
}

})